module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheada2-cbe22040eed600521acfdacb0c08ba6a.jpg";